module.exports = __webpack_public_path__ + "img/4.205d58e0.png";